export type ThemePreference = 'system' | 'light' | 'dark'
export const THEME_STORAGE_KEY = 'bookwriter.theme'
const THEME_EVENT = 'bookwriter:theme'
let memoryPreference: ThemePreference | undefined

function valid(value: string | null): ThemePreference {
  return value === 'light' || value === 'dark' ? value : 'system'
}

export function getThemePreference(): ThemePreference {
  if (typeof window === 'undefined') return 'system'
  if (memoryPreference !== undefined) return memoryPreference
  try { return valid(window.localStorage.getItem(THEME_STORAGE_KEY)) } catch { return 'system' }
}

export function applyThemePreference(preference: ThemePreference): void {
  if (preference === 'system') document.documentElement.removeAttribute('data-theme')
  else document.documentElement.dataset.theme = preference
}

export function setThemePreference(preference: ThemePreference): void {
  memoryPreference = preference
  try {
    if (preference === 'system') window.localStorage.removeItem(THEME_STORAGE_KEY)
    else window.localStorage.setItem(THEME_STORAGE_KEY, preference)
  } catch { /* A blocked storage area must not prevent an in-session preference. */ }
  applyThemePreference(preference)
  window.dispatchEvent(new Event(THEME_EVENT))
}

export function subscribeThemePreference(listener: () => void): () => void {
  const sync = () => { applyThemePreference(getThemePreference()); listener() }
  const storage = (event: StorageEvent) => {
    if (event.key !== null && event.key !== THEME_STORAGE_KEY) return
    memoryPreference = undefined
    sync()
  }
  window.addEventListener(THEME_EVENT, sync)
  window.addEventListener('storage', storage)
  return () => {
    window.removeEventListener(THEME_EVENT, sync)
    window.removeEventListener('storage', storage)
  }
}

// Runs before paint with the request nonce. Values are a fixed allowlist, never HTML.
export const themeInitScript = `try{var t=localStorage.getItem('${THEME_STORAGE_KEY}');if(t==='light'||t==='dark')document.documentElement.setAttribute('data-theme',t)}catch(e){}`
